import { render, staticRenderFns } from "./IndependentReview.vue?vue&type=template&id=d9a736ba&scoped=true"
import script from "./IndependentReview.vue?vue&type=script&lang=js"
export * from "./IndependentReview.vue?vue&type=script&lang=js"
import style0 from "./IndependentReview.vue?vue&type=style&index=0&id=d9a736ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a736ba",
  null
  
)

export default component.exports